import { create } from "jss";
import rtl from "jss-rtl";
import { jssPreset, StylesProvider } from "@material-ui/core/styles";

// Configure JSS
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

function ThemeRtl(props) {
  return <StylesProvider jss={jss}>{props.children}</StylesProvider>;
}

export default ThemeRtl;
